import React, { Component } from "react";
import styles from "./modalConfirmWindow.module.scss";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";

class DeleteConfirm extends Component {
  render() {
    const { onConfirmHandle = (e) => {}, onNotConfirmHandle = (e) => {}, text = "Удалить?" } = this.props;

    const textisArray = Array.isArray(text);

    return (
      <div className={styles.deleteConfirmContainer}>
        {textisArray ? (
          <div>
            {text.map((item, index) => {
              return <div key={index}> {item}</div>;
            })}
          </div>
        ) : (
          <div>{text}</div>
        )}

        <div className={styles.confirmButtonsContainer}>
          <div className={styles.confirmButtonContainer}>
            <ButtonPrimary
              handleClick={(e) => {
                e.stopPropagation();
                onConfirmHandle(e);
              }}
              title="Да"
            />
          </div>
          <div className={styles.confirmButtonContainer}>
            <ButtonPrimary
              handleClick={(e) => {
                e.stopPropagation();
                onNotConfirmHandle(e);
              }}
              title="Отмена"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default React.memo(DeleteConfirm);
